import { Pagination } from "@mui/material";

function CustomPagination({ currentPage, totalPages, onPageChange }) {
  return (
    <div className="flex justify-center mt-8">
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={onPageChange}
        color="primary"
        size="large"
        siblingCount={1}
        boundaryCount={1}
        sx={{
          "& .MuiPaginationItem-root": {
            width: "45px",
            height: "45px",
            borderRadius: "50%",
            color: "#fff",
            border: "1px solid #555",
            transition: "all 0.5s ease",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "#1e293b",
              transform: "translateY(-4px) scale(1.1)",
              boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
            },

            "&.Mui-selected": {
              backgroundImage:
                "linear-gradient(135deg, #0ea5e9 0%, #6366f1 100%)",
              color: "#fff",
              fontWeight: "bold",
              transform: "rotate(360deg) scale(1.1)",
              transition: "all 0.8s ease",
              border: "none",
              boxShadow: "0px 4px 15px rgba(99, 102, 241, 0.5)",
            },
          },
        }}
      />
    </div>
  );
}

export default CustomPagination;
